import { render, staticRenderFns } from "./screenList.vue?vue&type=template&id=2fd2ef6d&scoped=true&"
import script from "./screenList.vue?vue&type=script&lang=js&"
export * from "./screenList.vue?vue&type=script&lang=js&"
import style0 from "./screenList.vue?vue&type=style&index=0&id=2fd2ef6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2ef6d",
  null
  
)

component.options.__file = "screenList.vue"
export default component.exports